<template>
  <div class="row w-100 p-content-list pr-4 pl-4">
      <div class="row w-100 p-management-commission-main">
            <div class="w-100 d-flex flex-wrap p-list-representation-province-data-item mt-4 mb-4">
                  <div class="row p-salon-map-item ml-3 align-items-center">
                    <h3 class="p-salon-map-item-title">نام سالن:</h3>
                    <h3 class="p-salon-map-item-title mr-1">{{nameSalon}}</h3>
                  </div>
                  <div class="row p-salon-map-item ml-3 align-items-center">
                    <h3 class="p-salon-map-item-title">
                      نام صاحب سالن:
                    </h3>
                    <h3 class="p-salon-map-item-title  mr-1">
                      {{NameFamilySalonDar}}
                    </h3>
                  </div>
            </div>
      </div>

      <modalEditCommission
       @closeModalCommission="closeModalCommission"
       :active.sync="statusModalEditCommission"
        @submitEditCommission="submitEditCommission"
        :value-modal="valueModal"
        :loading="loading"
         />

  </div>
</template>

<script>
import modalEditCommission from './modalEditCommission';


export default {
  name: "contentList",
  components: {
    modalEditCommission,
  },

  props: {
    valueModal                  : {type:Object,default:{}},
    showModalEditCommission     : {type:Boolean,default:false},
    loading                     : {type:Boolean,default:false},
  },

  data() {
    return {
      statusModalEditCommission    : false,
      nameSalon                    : '',
      NameFamilySalonDar           : '',
    }
  },

  watch: {
    showModalEditCommission(status){
      this.statusModalEditCommission = status;
    },

  },

  created() {

  },

  mounted() {
    const getQueryNameSalon          = this.$route.query.name;
    const getQueryNameFamilySalonDar = this.$route.query.nameFamilySalonDar;

    if (typeof(getQueryNameFamilySalonDar) != 'undefined') {
      this.nameSalon          = getQueryNameSalon;
      this.NameFamilySalonDar = getQueryNameFamilySalonDar;
    }

  },

  methods: {
    submitEditCommission(data){
      this.$emit('submitEditCommission',data)
    },

    closeModalCommission(status){
        this.$emit('closeModalCommission',status);
    }

  }


}
</script>
